import React from 'react';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import Button from '../../components/Button/Button';
import Card from '../../components/Card/Card';
import styles from './Contact.module.css';

const Contact = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    // Form submission logic will be added later
    alert('Form submitted (demo)');
  };

  return (
    <div className={styles.contact}>
      {/* Header – full width */}
      <section className={styles.header}>
        <h1 className={styles.pageTitle}>Contact Us</h1>
        <p className={styles.pageSubtitle}>Get in touch with the Idoma Medical Doctors Foundation</p>
      </section>

      {/* Contact Info Cards */}
      <section className={styles.infoCards}>
        <Card variant="elevated" className={styles.infoCard}>
          <div className={styles.icon}>📍</div>
          <h3>Visit Us</h3>
          <p>Headquarters<br />Abuja, Nigeria</p>
          <p className={styles.note}>(Physical address available upon request)</p>
        </Card>
        <Card variant="elevated" className={styles.infoCard}>
          <div className={styles.icon}>📞</div>
          <h3>Call Us</h3>
          <p>+234 123 456 7890</p>
          <p>+234 987 654 3210</p>
        </Card>
        <Card variant="elevated" className={styles.infoCard}>
          <div className={styles.icon}>✉️</div>
          <h3>Email Us</h3>
          <p>info@imdf.org.ng</p>
          <p>secretary@imdf.org.ng</p>
        </Card>
      </section>

      {/* Contact Form & Map */}
      {/* <section className={styles.formMap}>
        <div className={styles.formContainer}>
          <SectionTitle title="Send a Message" subtitle="We'd love to hear from you" />
          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.formGroup}>
              <label htmlFor="name">Full Name *</label>
              <input type="text" id="name" name="name" required />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="email">Email Address *</label>
              <input type="email" id="email" name="email" required />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="subject">Subject</label>
              <input type="text" id="subject" name="subject" />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="message">Message *</label>
              <textarea id="message" name="message" rows="5" required></textarea>
            </div>
            <Button type="submit" variant="primary" size="large">Send Message</Button>
          </form>
        </div>
        <div className={styles.mapContainer}>
          <SectionTitle title="Find Us" subtitle="Our location" />
          <div className={styles.mapPlaceholder}>
            <p>Map will be embedded here</p>
            <p className={styles.mapNote}>(Google Maps integration coming soon)</p>
          </div>
        </div>
      </section> */}

      {/* Social Media */}
      {/* <section className={styles.social}>
        <SectionTitle title="Connect With Us" subtitle="Follow us on social media" align="center" />
        <div className={styles.socialIcons}>
          <a href="#" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>f</a>
          <a href="#" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>t</a>
          <a href="#" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>in</a>
          <a href="#" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>ig</a>
        </div>
      </section> */}
    </div>
  );
};

export default Contact;